package com.example.mystybag.common.ui.components.custom

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.StrokeCap
import com.example.mystybag.core.ui.theme.LocalTheme.p3
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p48
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.ui.theme.LocalTheme.p4
import com.example.mystybag.core.ui.theme.LocalTheme.p0
import com.example.mystybag.core.views.AppTheme

@Composable
fun ProgressNotch(
    modifier    : Modifier      = Modifier,
    color       : Color         = AppTheme.current.colors.primary,
    trackColor  : Color         = AppTheme.current.colors.outline,
    duration    : Int           = 5_000,
    onTimeout   : (() -> Unit)? = null
) {

    val targetValue = remember { mutableStateOf(0f) }
    val progress = onTimeout?.let { timeOut ->
        animateFloatAsState(
            targetValue     = targetValue.value,
            animationSpec   = tween(
                durationMillis  = duration,
                easing          = LinearEasing
            ),
            finishedListener = {
                timeOut()
            }
        )
    } ?: mutableStateOf(0f)

    onTimeout?.also {
        LaunchedEffect(Unit) {
            targetValue.value = 1f
        }
    }

    LinearProgressIndicator(
        modifier            = Modifier
            .padding(top = p8, bottom = p16)
            .size(width = p48, height = p4)
            .clip(RoundedCornerShape(p3))
            .then(modifier),
        progress            = { progress.value },
        color               = color,
        trackColor          = trackColor,
        strokeCap           = StrokeCap.Butt,
        gapSize             = p0,
        drawStopIndicator   = { }
    )
}